import React, { useMemo } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'antd'

const IconButton = ({ className = '', disabled, ghost, icon, loading = false, size, text = '', type, onClick }) => {
  const localText = useMemo(() => text.length > 0 ? (<span> &nbsp; {text} </span>) : text, [text])

  return (
    <Button
      className={className}
      disabled={disabled ?? false}
      loading={loading}
      size={size ?? 'default'}
      type={type ?? 'default'}
      ghost={ghost}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={icon} />
      {localText}
    </Button>
  )
}

export default IconButton
